import { Modal, Stack, TextInput, Button, Group } from "@mantine/core";
import { useForm } from "react-hook-form";
import { IconDownload } from "@tabler/icons-react";
import { useGenerateDocument } from "../../api/user";

const AVAILABLE_PLACEHOLDERS = [
  { value: "fullName", label: "Full Name" },
  { value: "firstName", label: "First Name" },
  { value: "lastName", label: "Last Name" },
  { value: "date", label: "Date" },
  { value: "eventName", label: "Event Name" },
];

export default function GenerateDocumentModal({ opened, onClose, template }) {
  const { handleSubmit, register } = useForm();
  const { mutate: generateDocument, isPending } = useGenerateDocument({
    id: template?.id,
  });

  const onSubmit = (values) => {
    generateDocument(values, {
      onSuccess: () => {
        onClose();
      },
    });
  };

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title={`Generate ${template?.name}`}
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        <Stack>
          {AVAILABLE_PLACEHOLDERS.map((placeholder) => (
            <TextInput
              key={placeholder.value}
              label={placeholder.label}
              placeholder={`Enter value for ${placeholder.label}`}
              {...register(placeholder.value)}
            />
          ))}

          <Group justify="flex-end" mt="md">
            <Button variant="light" color="gray" onClick={onClose}>
              Cancel
            </Button>
            <Button
              type="submit"
              leftSection={<IconDownload size={16} />}
              loading={isPending}
            >
              Generate PDF
            </Button>
          </Group>
        </Stack>
      </form>
    </Modal>
  );
}
